import { RouteConfig, SideLink } from '@/types/utility.types'

export const importRoutes = () => {
  const modules = import.meta.glob('./pages/*.{ts,tsx}', { eager: true })
  return {
    routes: Object.keys(modules)
      .map((key) => {
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        const module = modules[key] as any
        return module.default as RouteConfig
      })
      .flat(),
    sidelinks: Object.keys(modules).map((key) => {
      /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
      const module = modules[key] as any
      return module?.sidelink as SideLink
    }),
  }
}

const { routes: childRoutes, sidelinks } = importRoutes()

export { sidelinks }
export default childRoutes
